import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { adminService } from '../../../services/adminService';

export default function ActivityFeed() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadActivities();
  }, []);

  const loadActivities = async () => {
    try {
      const data = await adminService?.getRecentActivities();
      setActivities(data || []);
    } catch (err) {
      console.error('Failed to load activities:', err);
    } finally {
      setLoading(false);
    }
  };

  const getActivityIcon = (type) => {
    const iconMap = {
      user_registered: 'UserPlus',
      booking_completed: 'CheckCircle',
      payment_received: 'DollarSign',
      system_alert: 'AlertTriangle',
    };
    return iconMap?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colorMap = {
      user_registered: '#3b82f6',
      booking_completed: '#10b981',
      payment_received: '#a855f7',
      system_alert: '#f59e0b',
    };
    return colorMap?.[type] || '#64748b';
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
          النشاط الحالي
        </h2>
        <Icon name="Activity" size={20} color="#64748b" />
      </div>

      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
        </div>
      ) : activities?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Inbox" size={48} color="#cbd5e1" className="mx-auto mb-2" />
          <p className="text-slate-500" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>لا توجد أنشطة حديثة</p>
        </div>
      ) : (
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {activities?.map((activity) => (
            <div key={activity?.id} className="flex items-start gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors">
              <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0">
                <Icon name={getActivityIcon(activity?.type)} size={16} color={getActivityColor(activity?.type)} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-slate-900 font-medium" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
                  {activity?.title}
                </p>
                <p className="text-xs text-slate-600 mt-1" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
                  {activity?.description}
                </p>
                <p className="text-xs text-slate-400 mt-1">{activity?.timestamp}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}